import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHeader from "./SectionHeader";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeader
          index="05"
          kicker="常见问题"
          title="关于「69吃瓜」与事件梳理"
          desc="关于信息来源、口径处理、修订流程与时间线规则，最常被问到的问题都在这里一次讲清。"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.6fr_1fr]">
          {/* accordion */}
          <div className="space-y-3">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-xl border bg-background-50 transition-colors ${
                    open ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <button
                    onClick={() => setOpenIdx(open ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-semibold text-foreground-950">{f.q}</span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all ${
                        open ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-100 text-foreground-500"
                      }`}
                    >
                      <i className="ri-arrow-down-s-line text-base" />
                    </span>
                  </button>
                  {open && (
                    <div className="px-5 pb-5">
                      <p className="border-t border-background-200 pt-4 text-sm leading-relaxed text-foreground-600">
                        {f.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* right feedback card */}
          <aside className="flex flex-col gap-6">
            <div className="rounded-xl border border-background-200 bg-background-50 p-5">
              <h3 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
                <i className="ri-feedback-line text-primary-600" />
                对某段经过有疑问？
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                提交你认为有误的节点与原始证据，编辑核对后会在 48 小时内修订，并保留修订记录供复核。
              </p>
              <div className="mt-4 space-y-2.5">
                <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-3.5 py-3">
                  <i className="ri-link text-primary-600" />
                  <span className="text-sm text-foreground-600">粘贴可信原文链接</span>
                </div>
                <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-3.5 py-3">
                  <i className="ri-file-text-line text-primary-600" />
                  <span className="text-sm text-foreground-600">可补充截图 / 音视频证据</span>
                </div>
              </div>
              <a
                href="#faq"
                className="mt-4 inline-flex w-full items-center justify-center rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-accent-600 cursor-pointer"
              >
                提交纠错反馈
              </a>
              <p className="mt-3 text-center text-xs text-foreground-400">
                所有反馈均需两名以上编辑交叉核验
              </p>
            </div>

            <div className="rounded-xl bg-foreground-950 p-5 text-background-50">
              <h3 className="font-heading text-lg">想持续追瓜不漏更？</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-300">
                把热榜与专题动态收藏起来，或留意每日 09:00 的固定更新时段，第一时间看到新瓜的前因后果。
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                {["每日 09:00", "每周热度总榜", "反转自动提醒"].map((t) => (
                  <span
                    key={t}
                    className="rounded-full border border-background-700 px-3 py-1 text-xs text-background-200 whitespace-nowrap"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}